import { Row, Col, Button } from "react-bootstrap";
import { Link } from 'react-router-dom'

import styles from "./MakeProposalSection.module.css";

function MakeProposalSection() {
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex align-items-center">
                <div>
                    <div className={styles.makeProposalTitle}>Make Your Own Proposal</div>
                    <div className={styles.makeProposalSubtext}>Acquiring funds to develop a business or run a charity can be a challenging part for most founders. Voton enables you to reach out to the masses with your business or project proposal and facilitates raising capital through democratic funding. If you have a project proposal that needs capital, here's your chance to start raising funds.</div>

                    <Link to="/propose">
                        <Button className={styles.makeProposalButtons}>
                            <div className={styles.makeProposalButtonText}>Make a Proposal</div>
                        </Button>
                    </Link>
                </div>
            </Col>
        </Row>
    );
}

export default MakeProposalSection;